
import {
  Vue,
  Component,
  PropSync,
  Ref,
  Watch,
  Prop,
} from "vue-property-decorator";
import DateRangeCustom from "@/components/Base/DateRange/DateRangeCustom.vue";
import DateRangePredefined from "@/components/Base/DateRange/DateRangePredefined.vue";
import {
  getCustomOrPredefinedStartDate,
  getCustomOrPredefinedEndDate,
} from "@/helpers/Dates/DateHelpers";

@Component({
  components: { DateRangeCustom, DateRangePredefined },
})
export default class DateRangeCustomOrPredefined extends Vue {
  @PropSync("includeAllDatesOption", { required: false, default: false })
  includeAllDatesOptionSync!: boolean;

  @Prop({ required: false, default: "Date" })
  label!: string;

  @PropSync("fromDate", { type: String })
  fromDateSync!: string;

  @PropSync("toDate", { type: String })
  toDateSync!: string;

  @PropSync("repositoryFromDate", { type: String })
  repositoryFromDateSync!: string;

  @PropSync("repositoryEndDate", { type: String })
  repositoryEndDateSync!: string;

  @PropSync("isCustomDateRange", { type: Boolean })
  isCustomDateRangeSync!: boolean;

  @PropSync("predefinedDateRangeType", { type: String })
  predefinedDateRangeTypeSync!: string;

  @Ref()
  dateRangeCustom!: DateRangeCustom;

  @Ref()
  dateRangePredefined!: DateRangePredefined;

  mounted() {
    this.updateRepoFilterDateRange(true, true);
  }

  public isValid(): boolean {
    if (this.isCustomDateRangeSync) {
      return this.dateRangeCustom.isValid();
    } else {
      return true;
    }
  }

  updateRepoFilterDateRange(updateStartDate: boolean, updateEndDate: boolean) {
    if (updateStartDate) {
      this.repositoryFromDateSync = getCustomOrPredefinedStartDate(
        this.isCustomDateRangeSync,
        this.fromDateSync,
        this.predefinedDateRangeTypeSync
      );
    }

    if (updateEndDate) {
      this.repositoryEndDateSync = getCustomOrPredefinedEndDate(
        this.isCustomDateRangeSync,
        this.toDateSync,
        this.predefinedDateRangeTypeSync
      );
    }
  }

  @Watch("fromDateSync")
  fromDateSyncChange() {
    this.updateRepoFilterDateRange(true, false);
  }

  @Watch("toDateSync")
  toDateSyncChange() {
    this.updateRepoFilterDateRange(false, true);
  }

  @Watch("isCustomDateRangeSync")
  isCustomDateRangeSyncChange() {
    this.updateRepoFilterDateRange(true, true);
  }

  @Watch("predefinedDateRangeType")
  predefinedDateRangeTypeChange() {
    this.updateRepoFilterDateRange(true, true);
  }
}
